export const fixedFeeTitle = 'Fee Fixo';
export const fixedFeeDescription =
  'Remuneração definida por uma taxa fixa percentual aplicada sobre o patrimônio do cliente';
